/** Tabular view for results that are not graph-shaped, too large, ASK or CONSTRUCT (spec §15.4, §15.5). */
import type { QueryResult } from "../api/hooks";
import { useT } from "../i18n";

const MAX_ROWS = 500;

export function ResultTable({ result }: { result: QueryResult }) {
  const t = useT();
  if (result.kind === "boolean") {
    return <div className="p-3 text-sm" data-testid="result-boolean">ASK → <b>{String(result.results.boolean)}</b></div>;
  }
  if (result.kind === "triples") {
    return <pre className="overflow-auto p-3 text-xs" data-testid="result-triples">{result.results.ntriples}</pre>;
  }
  const vars = result.results.head?.vars ?? [];
  const rows = result.results.results?.bindings ?? [];
  return (
    <div className="overflow-auto" data-testid="result-table">
      <table className="w-full border-collapse text-xs">
        <thead>
          <tr>
            {vars.map((v) => (
              <th key={v} className="sticky top-0 border-b border-neutral-300 bg-neutral-50 px-2 py-1 text-left dark:border-neutral-700 dark:bg-neutral-900">?{v}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.slice(0, MAX_ROWS).map((row, i) => (
            <tr key={i} className="border-b border-neutral-100 dark:border-neutral-800">
              {vars.map((v) => (
                <td key={v} className="max-w-xs truncate px-2 py-0.5" title={row[v]?.value}>
                  {row[v]?.value ?? ""}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {rows.length > MAX_ROWS && <p className="p-2 text-xs text-neutral-500">{t("results.showing", { shown: MAX_ROWS, total: rows.length })}</p>}
    </div>
  );
}
